import { View, Keyboard } from 'react-native';
import { useState } from 'react';
import AuthPage, { AuthHeader, AuthInput as Input, AuthButton as SolidButton } from '@/components/General/AuthPage';
import PasswordChecklist from '@/components/General/PasswordChecklist';
import Toast from 'react-native-toast-message'
import { supabase } from '@/data/client';
import { useRouter, useLocalSearchParams } from 'expo-router';


const ResetPasswordScreen = () => {
    const router = useRouter();
    const { isForcedReset, isRecovery, recoveryEmail } = useLocalSearchParams();

    const [recoveryCode, setRecoveryCode] = useState("");
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [newPasswordConfirm, setNewPasswordConfirm] = useState("");
    const [signingIn, setSigningIn] = useState(false);

    const submitForgotPassword = async () => {
        const { error } = await supabase.auth.verifyOtp({ email: recoveryEmail, token: recoveryCode, type: 'recovery' })

        if(error){
            setSigningIn(false);
            Toast.show({type: 'error', text2: "It appears that the code you entered is incorrect or expired. Please double check, or go back and request a new one."})
            return false;
        }
        else{
            setSigningIn(false);
            const { error1 } = await supabase.auth.updateUser({ password: newPassword })

            if(error1){
                Toast.show({type: 'error', text2: "Hmm... Something weird happened. Try again in a bit."})
                return false;
            }

            Toast.delayShow({type: 'success', text2: "Your password has been successfully reset. You may now log in"})
            router.push("/auth/login");
        }
    }


    const changePassword = async () => {
        if(!oldPassword || !newPassword){
            Toast.show({type: 'error', text2: "Be sure to fill out the your old and new password!"})
            setSigningIn(false);
            return false;
        }

        try {
            const { error } = await supabase.auth.updateUser({ password: newPassword })

            if(error){
                if(error.name == "AuthWeakPasswordError"){
                    if(error.message.includes("Password should contain at least one character of each")){
                        Toast.show({type: 'error', text2: `That password isn't quite secure enough: You should have at least one uppercase letter, one lowercase letter, one number, and one special character .`})
                    }
                    else{
                        Toast.show({type: 'error', text2: `That password isn't quite secure enough: ${error.message}`})
                    }
                }
                else if(error.message == "New password should be different from the old password."){
                    Toast.show({type: 'error', text2: error.message})
                }
                else{
                    Toast.show({type: 'error', text2: "Hmm... Looks like we can't update your password right now. Try again in a bit."})
                }

                setSigningIn(false);
                return false;
            }

            Toast.delayShow({type: 'success', text2: "Your password has been successfully reset!"});
            router.back();

            setSigningIn(false);
          } catch(err) {
            setSigningIn(false);

            if(err.code == "InvalidPasswordException"){
                Toast.show({type: 'error', text2: "That password isn't quite secure enough... Be sure it follows the given password rules!"})
            }
            else{
                Toast.show({type: 'error', text2: "Hmm... Something weird happened. Try again in a bit."})
            }
          }
    }

    return (
        <AuthPage maxWidth={520} showBack>
                <AuthHeader
                    eyebrow="Account security"
                    title="Reset your password"
                    description={isRecovery ? 'Enter the code we sent you along with your new password.' : 'Choose a new password to keep your account secure.'}
                />
        
                { !isForcedReset
                    && (!isRecovery
                        ? <View style={{width:"100%"}}>
                            <Input
                                title="Current Password"
                                secureTextEntry={true}
                                autoComplete="current-password"
                                value={oldPassword}
                                onUpdate={(new_value) => {
                                    setOldPassword(new_value);
                                }}
                            />
                        </View>
                        : <View style={{width:"100%"}}>
                            <Input
                                title="Recovery Code"
                                textContentType="oneTimeCode"
                                autoComplete='one-time-code'
                                value={recoveryCode}
                                onUpdate={(new_value) => {
                                    setRecoveryCode(new_value);
                                }}
                            />
                        </View>)
                }
        
                <View style={{width:"100%"}}>
                    <Input
                        key="new_password"
                        title="New Password"
                        secureTextEntry={true}
                        autoComplete='new-password'
                        textContentType="newPassword"
                        value={newPassword}
                        onUpdate={(new_value) => {
                            setNewPassword(new_value);
                        }}
                    />
                </View>
        
                <View style={{width:"100%"}}>
                    <Input
                        key="new_password_confirm"
                        title="Confirm New Password"
                        autoComplete='new-password'
                        textContentType="newPassword"
                        secureTextEntry={true}
                        value={newPasswordConfirm}
                        onUpdate={(new_value) => {
                            setNewPasswordConfirm(new_value);
                        }}
                    />
                </View>

                <PasswordChecklist password={newPassword} confirmation={newPasswordConfirm} />
        
                <View style={{width:"100%"}}>
                    <SolidButton processing={signingIn} onPress={async () => {
                        Keyboard.dismiss();
        
                        if(newPassword != newPasswordConfirm){
                            Toast.show({type: 'error', text2: "Passwords do not match! Make sure you're typing your password in correctly in both places."})
                        }
                        else{
                            setSigningIn(true);
        
                            if(isRecovery){
                                submitForgotPassword();
                            }
                            else if(isForcedReset){
                                //forceResetPassword();
                            }
                            else{
                                changePassword();
                            }
                        }
        
                    }} text="Reset Password" size="md"/>
                </View>
        </AuthPage>
    );
}

export default ResetPasswordScreen